import Subject from "../cse4sub/Subject";
import React from 'react'
import CSE306 from '../assets/CSE306end21.pdf'


export default function DsLab() {
  return (
    <div>
       <Subject title="Data Structure Lab(CSE306)" 
    book1=" " book2=" "
    book1Link="#" book2Link="#" int21="#" mid21="#" end21={CSE306}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}